export default __webpack_public_path__ + "static/media/she-code-africa-logo.9505b2f3.svg";